import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { FirestoreProvider } from './contexts/FirestoreContext.jsx';
import { MultiCmtProvider } from './contexts/MultiCmtContext.jsx';
import { TimelineProvider } from './contexts/TimelineContext.jsx';
import { MilestoneDataProvider } from './contexts/MilestoneDataContext.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Layout from './components/Layout.jsx';
import PrivateRoute from './components/PrivateRoute.jsx';
import AccessDeniedScreen from './components/auth/AccessDeniedScreen.jsx';
import CMTIssuesBanner from './components/auth/CMTIssuesBanner.jsx';
import MyCrisisResources from './pages/MyCrisisResources.jsx';
import AICrisisAdviser from './pages/AICrisisAdviser.jsx';
import Incidents from './pages/Incidents.jsx';
import IncidentDetails from './pages/IncidentDetails.jsx';
import NewIncident from './pages/NewIncident.jsx';
import Reports from './pages/Reports.jsx';
import Map from './pages/Map.jsx';
import Documents from './pages/Documents.jsx';
import DocumentViewer from './components/DocumentViewer.jsx';
import NewDocument from './pages/NewDocument.jsx';
import Admin from './pages/Admin.jsx';
import Help from './pages/Help.jsx';
import OnboardingWizard from './pages/OnboardingWizard.jsx';
import DigitalProductViewer from './pages/DigitalProductViewer.jsx';
import CrisisCommunicationViewer from './pages/CrisisCommunicationViewer.jsx';
import BusinessContinuityViewer from './pages/BusinessContinuityViewer.jsx';
import OrgSettings from './pages/OrgSettings.jsx';
import { initializeFirebaseErrorSuppression } from './utils/firebaseErrorSuppressor.js';

function App() {
  // Initialize Firebase error suppression on app start
  useEffect(() => {
    initializeFirebaseErrorSuppression();
  }, []);

  return (
    <Router>
      <AuthProvider>
        <FirestoreProvider>
          <MultiCmtProvider>
            <TimelineProvider>
              <MilestoneDataProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              
              {/* Protected routes */}
              <Route element={<PrivateRoute />}>
                <Route element={<Layout />}>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/my-crisis-resources" element={<MyCrisisResources />} />
                  <Route path="/digital-products/:productId/:cmtId?" element={<DigitalProductViewer />} />
                  <Route path="/crisis-communication-plan/:cmtId?" element={<CrisisCommunicationViewer />} />
                  <Route path="/business-continuity-plan/:cmtId?" element={<BusinessContinuityViewer />} />
                  <Route path="/ai-crisis-adviser" element={<AICrisisAdviser />} />
                  <Route path="/incidents" element={<Incidents />} />
                  <Route path="/incidents/:id" element={<IncidentDetails />} />
                  <Route path="/incidents/new" element={<NewIncident />} />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="/map" element={<Map />} />
                  <Route path="/documents" element={<Documents />} />
                  <Route path="/documents/view/:documentId" element={<DocumentViewer />} />
                  <Route path="/documents/new" element={<NewDocument />} />
                  <Route path="/help" element={<Help />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/org-settings" element={<OrgSettings />} />
                  <Route path="/onboarding" element={<OnboardingWizard />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Route>
              </Route>
            </Routes>
              </MilestoneDataProvider>
            </TimelineProvider>
          </MultiCmtProvider>
        </FirestoreProvider>
      </AuthProvider>
    </Router>
  );
}

export default App; 